// removed by extract-text-webpack-plugin
module.exports = {"selectWrapper":"_8hRirukZoVOSnZJVAozVg","select":"_1ZpVgfjIpL1nKsot4PXgLU"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ChannelList/style.css
 ** module id = 593
 ** module chunks = 0
 **/